import React, { useRef } from 'react'
import {
  BankModalContainer,
  BankWrapper,
  BankModalBackground,
  ClosedModalButton,
} from './style'
import { PlanAmount } from '../PlanAmount'

const PlanAmountModal = ({ showModal, setShowModal }: any) => {
  const componentRef = useRef<HTMLDivElement>(null)

  const closeModal = (e: any) => {
    if (componentRef.current !== e.target) {
      setShowModal(false)
    }
  }

  return (
    <BankModalContainer>
      {showModal ? (
        <BankModalBackground>
          <BankWrapper>
            <ClosedModalButton onClick={closeModal} />
            <PlanAmount />
          </BankWrapper>
        </BankModalBackground>
      ) : null}
    </BankModalContainer>
  )
}

export { PlanAmountModal }
